import DaySchedulings from "./DaySchedulings";
import { ServiceBaySchedule } from "../../../../../../models/serviceBay";

interface INextSchedulingsProps {
  todaySchedule: ServiceBaySchedule[];
  tomorrowSchedule: ServiceBaySchedule[];
}

const NextSchedulings = (props: INextSchedulingsProps) => {
  const { todaySchedule, tomorrowSchedule } = props;

  return (
    <div>
      <DaySchedulings dayTitle="Hoje" vehicles={todaySchedule.map(schedule => schedule.occurrence?.vehicleModel || schedule.occurrence?.vehicleName || "")} />
      <DaySchedulings dayTitle="Amanhã" vehicles={tomorrowSchedule.map(schedule => schedule.occurrence?.vehicleModel || schedule.occurrence?.vehicleName || "")} />
    </div>
  );
};

export default NextSchedulings;
